import { NgModule } from '@angular/core';
import { UiTimerDirective } from './ui-timer.directive';
import { UiTimerWrapperComponent } from './ui-timer-wrapper/ui-timer-wrapper.component';

@NgModule({
	declarations: [
		UiTimerDirective,
		UiTimerWrapperComponent
	],
	exports: [
		UiTimerDirective,
		UiTimerWrapperComponent
	]
})
export class UiTimerDirectiveModule {}
